/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Mark_Done_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Mark notes as done" |
*
* @param {Notes_Mark_Done_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_mark_done_aria_label = /** @type {((inputs?: Notes_Mark_Done_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Mark_Done_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marquer les notes comme terminees")
	if (locale === "de") return /** @type {LocalizedString} */ ("Markieren Sie die Notizen als erledigt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Segna le note come completate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отметить заметки как выполненные")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcar notas como realizadas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标记笔记已完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メモを完了としてマークする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नोट्स को पूरा हुआ चिह्नित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marcar notas como concluídas")
	return /** @type {LocalizedString} */ ("Mark notes as done")
});